import { useTranslations } from '@vocab/react';
import { ButtonLink, IconStatistics } from 'braid-design-system';

import translations from './.vocab';
import { NudgeBanner } from './NudgeBanner';

const VISIBILITY_SETTING_URL = '/profile/me/profile-visibility-v2?mode=edit';

export const NudgeProfilePublicBanner = () => {
  const { t } = useTranslations(translations);
  return (
    <NudgeBanner
      title={
        <>
          {t('NOT_MANY_RESULT_YET')} {t('BUT_WE_ARE_GROWING_FAST')}
        </>
      }
      description={t(
        'WE_HAVE_MILLIONS_OF_PROFILES_BUT_APPEAR_ONLY_WHEN_MADE_PROFILES_PUBLIC',
      )}
      actionButton={
        <ButtonLink
          href={VISIBILITY_SETTING_URL}
          icon={<IconStatistics />}
          tone="brandAccent"
        >
          {t('MAKE_YOUR_PROFILE_PUBLIC')}
        </ButtonLink>
      }
    />
  );
};
